import {eventBus} from "@/application/EventBus";
import DeleteDialog from "@/components/Dialogs/DeleteDialog.vue";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";


export interface DialogSettings {
    title?: string;
    message?: string;
    onAccept?: () => void;
    onCancel?: () => void;
}

function deleteDialog(settings: DialogSettings) {
    eventBus.openModal(
        DeleteDialog,
        {
        title: settings.title || 'Löschen',
        message: settings.message || 'Bist du sicher, dass du das Element löschen möchtest?',
        onAccept: settings.onAccept || (() => {}),
        onCancel: settings.onCancel || (() => {})
    });
}

function okDialog(settings: DialogSettings) {
    eventBus.openModal(
        SuccessConfirmation,
        {
        title: settings.title || 'Bestätigung',
        message: settings.message || 'Bist du sicher, dass du das Element löschen möchtest?',
        onAccept: settings.onAccept || (() => {})
    });
}

export const dialog = {
    deleteDialog,
    okDialog
}